import React from "react";
import { useMediaQuery } from "react-responsive";
import {
  convertTo12HourFormat,
  handleDateSetUp
} from "../../../../helpers/helpers";
import { useNavigate } from "react-router-dom";

function LiveOffer({ singleOffer }) {
  const navigate = useNavigate();
  const isMobile = useMediaQuery({ query: "(max-width: 450px)" });

  if (!singleOffer) {
    return <div>Loading...</div>;
  }

  return (
    <div
      style={{
        width: "49.5%"
      }}
    >
      <div className="live-room-home" key={4}>
        <span className="green-light"></span>
        <div
          style={{
            position: "relative"
          }}
        >
          <span className="flex align-center space-between p-1 ">
            <span className="flex align-end ">
              <img
                src="../images/urlIcon.png"
                alt="auction-icon"
                style={{ width: "30px", height: "30px" }}
              />
              &nbsp;
              <span className="flex align-end green-text ">
                <span className="  material-symbols-outlined">task_alt</span>

                <p> {singleOffer.offer?.status}</p>
              </span>
            </span>

            <button
              className="join-btn "
              onClick={() => {
                navigate(
                  `/live-room/${singleOffer.auction?._id}/${singleOffer.offer._id}`
                );
              }}
            >
              <p>Join</p>
              <span
                className="material-symbols-outlined small-text"
                style={{ marginTop: "3px" }}
              >
                east
              </span>
            </button>
          </span>

          <hr className="grey" />

          <span
            className={`valign-wrapper ${
              isMobile ? "column" : "space-between"
            } p-1`}
          >
            <span className="flex column center gap-1">
              <label className="font-14px">Auction ID</label>
              <h6 className="font-16px" style={{ marginTop: "2px" }}>
                {singleOffer.auction?.auctionId}
              </h6>
            </span>

            <span className="flex column center  gap-1 ">
              <label className="font-14px">Offer Number</label>
              <h6 className="font-16px" style={{ marginTop: "2px" }}>
                {singleOffer.offer?.offerNumber}
              </h6>
            </span>

            <span className="flex column center gap-1 ">
              <label className="font-14px">QTY-UOM</label>
              <h6 className="mb-1 font-16px" style={{ marginTop: "2px" }}>
                {singleOffer.offer?.scrapDetails?.quantity}-
                {singleOffer.offer?.scrapDetails?.unit}
              </h6>
            </span>

            <span className="flex column center  gap-1">
              <label className="font-14px">Starting price (INR)</label>
              <h6 className="mb-1 font-16px" style={{ marginTop: "2px" }}>
                {singleOffer.offer?.startingPrice}
              </h6>
            </span>

            <span className="flex column center  gap-1">
              <label className="font-14px">Min Increment (INR)</label>
              <h6 className="font-16px" style={{ marginTop: "2px" }}>
                {singleOffer.offer?.minBidIncrement}
              </h6>
            </span>
          </span>
          <hr className="grey" />

          <span className="flex column p-1">
            <span>
              Offer Date: &nbsp;{" "}
              {handleDateSetUp(singleOffer.offer?.offerSchedule?.startDate)}{" "}
            </span>
            <span>
              Offer Time: &nbsp;{" "}
              {convertTo12HourFormat(
                singleOffer.offer?.offerSchedule?.startTimeAndDate
              )}{" "}
              To{" "}
              {convertTo12HourFormat(
                singleOffer.offer?.offerSchedule?.endTimeAndDate
              )}{" "}
            </span>
          </span>
        </div>
      </div>
    </div>
  );
}

export default LiveOffer;
